// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2BQD2","error":"Textarea_error__yrf0h","readonly":"Textarea_readonly__2vZzg","disabled":"Textarea_disabled__1dzbP"};